export default __webpack_public_path__ + "static/media/TRUCK16.4b3d47dd.jpg";